import Grid from '@/global/components/ui/Grid'
import { CidadesEstado, estadosV2, getCidadesByUf } from '@acme/common'
import { Divider } from '@mui/material'
import axios from 'axios'
import {
    FormField,
    FormFieldAutocomplete,
    FormFieldSelect,
} from 'global/components/Form'
import { ChangeEvent, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { ViaCepApi } from 'types'

export function DadosEndereco() {
    const [cidades, setCidades] = useState<CidadesEstado[]>([])

    const { watch, setValue, getValues } = useFormContext()

    const uf = watch('uf'),
        ibge = watch('Cidade.ibge')

    function handleChangeCep(event: ChangeEvent<HTMLInputElement>) {
        const cep = event.target.value.replace(/\D/g, '')
        if (cep.length === 8) {
            axios
                .get<ViaCepApi>(`https://viacep.com.br/ws/${cep}/json/`)
                .then(
                    async ({
                        data: { logradouro: endereco, bairro, ibge, uf },
                    }) => {
                        setValue('uf', uf)
                        if (!getValues('endereco'))
                            setValue('endereco', endereco)
                        if (!getValues('bairro')) setValue('bairro', bairro)
                        await updateCidadesByUf(uf)
                        setValue('Cidade.ibge', Number(ibge))
                    },
                )
        }
    }

    async function updateCidadesByUf(uf: string) {
        if (!uf) return
        const cidades = await getCidadesByUf(uf)
        setCidades(cidades)
        if (
            ibge &&
            !cidades.find(cidade => Number(cidade.id) === Number(ibge))
        ) {
            setValue('Cidade.ibge', null)
        }
    }

    useEffect(() => {
        updateCidadesByUf(uf)
    }, [uf])

    return (
        <section id="endereco">
            <Divider sx={{ mb: 3, mt: 4, userSelect: 'none' }}>
                Endereço
            </Divider>
            <Grid container spacing={2} columns={24}>
                <Grid item xs={6}>
                    <FormField
                        name="cep"
                        label="CEP"
                        required
                        onChange={handleChangeCep}
                        options={{
                            blocks: [5, 3],
                            delimiter: '-',
                            numericOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormFieldSelect
                        name="uf"
                        label="UF"
                        required
                        options={estadosV2.map(({ sigla }) => ({
                            value: sigla,
                            label: sigla,
                        }))}
                    />
                </Grid>
                <Grid item xs={14}>
                    <FormFieldAutocomplete
                        name="Cidade.ibge"
                        label="Cidade de trabalho"
                        options={cidades.map(cidade => ({
                            value: Number(cidade.id),
                            label: cidade.nome,
                        }))}
                        required
                        isOptionEqualToValue={(a, b) => +a.value === +b}
                        getOptionLabel={v => {
                            return cidades.find(c => c.id === +v)?.nome || ''
                        }}
                    />
                </Grid>
                <Grid item xs={8}>
                    <FormField name="bairro" label="Bairro" required />
                </Grid>
                <Grid item xs={11}>
                    <FormField name="endereco" label="Endereço" required />
                </Grid>
                <Grid item xs={5}>
                    <FormField name="numero" label="Número" required />
                </Grid>
            </Grid>
        </section>
    )
}
